import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButtonContainer, NavigationButtonImage, NavigationButtonContent } from '../styles/NavigationButton';
import { color } from '../styles/helpers/variables';
import { SITE_ROOT_URL } from '../constants/endpoints';

export const NavigationButton = props => (
  <NavigationButtonContainer
    to={props.url}
    style={{ backgroundColor: props.bgColor ? props.bgColor : color.white }}
    mb={props.mb}
  >
    {props.image ? <NavigationButtonImage url={`${SITE_ROOT_URL}${props.image}`} /> : false}
    <NavigationButtonContent>{props.title}</NavigationButtonContent>
  </NavigationButtonContainer>
);

NavigationButton.defaultProps = {
  bgColor: null,
  image: null,
  mb: null
};

NavigationButton.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  image: PropTypes.string,
  mb: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/components/NavigationButton.js